import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, mergeMap } from "rxjs/operators";
import { DealOperationsService } from "../../shared/services/api/deal-operations.service";
import { mapErrorToAction, mapToPayloadProperty } from "../shared/utils/operators";
import {
  loadPortfolioDetails,
  loadPortfolioDetailsFail,
  loadPortfolioDetailsSuccess,
  loadPortfolios,
  loadPortfoliosFail,
  loadPortfoliosSuccess
} from "./portfolios.actions";

@Injectable()
export class PortfoliosEffects {
  constructor(
    private actions$: Actions,
    private service: DealOperationsService
  ) {}

  loadPortfolios$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPortfolios),
      mergeMap((action) =>
        this.service.getPortfolios(action.payload?.params ?? {}).pipe(
          map(({ items, total, totalPages }) => loadPortfoliosSuccess({ portfolios: items, total, totalPages })),
          mapErrorToAction(loadPortfoliosFail)
        )
      )
    )
  );

  loadPortfolioDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPortfolioDetails),
      mapToPayloadProperty('code'),
      mergeMap((code) =>
        this.service.getDealDetails(code).pipe(
          map(portfolio => loadPortfolioDetailsSuccess({ portfolio })),
          mapErrorToAction(loadPortfolioDetailsFail)
        )
      )
    )
  );
}
